import AjaxService from '../services/ajax-service';

export const createSecret = (password, authToken) => {
    return AjaxService({
        method: 'post',
        url: `auth/secret`,
        data: { password }
    }, false, authToken)
    .then(response => response.data);
}

export const verifyToken = (token, authToken) => {
    return AjaxService({
        method: 'post',
        url: `auth/secret/verify`,
        data: { token }
    }, false, authToken)
    .then(response => response.data);
}

export const loginWithToken = ({ token, email, password }) => {
    return AjaxService({
        method: 'post',
        url: `auth/signin/2fa_token`,
        data: { token, email, password }
    })
    .then(response => response.data);
}

export const disableTfa = ({ token, password }) => {
    return AjaxService({
        method: 'post',
        url: `users/2fa_disable`,
        data: { token, password }
    })
    .then(response => response.data);
}
